// extracted by mini-css-extract-plugin
export default {"categoryText":"CategoryButton_categoryText__bSpYw"};